// React Hook Form consts
export const mode = 'all';
export const reValidateMode = 'onChange';

export const allergenDairyKey = 'dairy';
export const allergenEggsKey = 'eggs';
export const allergenGlutenKey = 'gluten';
export const allergenNutsKey = 'nuts';
export const allergenShellfishKey = 'shellfish';
export const allergenSoyKey = 'soy';

export const dietaryHalalKey = 'halal';
export const dietaryKetoKey = 'keto';
export const dietaryKosherKey = 'kosher';
export const dietaryLowFodmapKey = 'lowFodmap';
export const dietaryLowSodiumKey = 'lowSodium';
export const dietaryOrganicKey = 'organic';
export const dietaryPaleoKey = 'paleo';
export const dietaryVeganKey = 'vegan';
export const dietaryVegetarianKey = 'vegetarian';
export const dietaryWhole30Key = 'whole30';
